<p-table [value]="states" [paginator]="true" [rows]="10" class="mt-3" styleClass="p-datatable-overflow">

  <ng-template pTemplate="caption">
    <div class="flex justify-content-center">
      <button
        [label]="'misc.addState' | transloco"
        [disabled]="!selection"
        (click)="addNewState()"
        pButton
        icon="pi pi-plus"
      ></button>
    </div>
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th scope="col">{{'attribute.element' | transloco}}</th>
      <th scope="col">{{'model.sensor' | transloco}}</th>
      <th scope="col">{{'attribute.state' | transloco}}</th>
      <th scope="col" class="text-right">{{'common.actions' | transloco}}</th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-state>
    <tr [class.p-highlight]="selection && (selection.id() === state.id)">
      <td (click)="changeSelectionById.emit(state.id)" class="cursor-pointer">
        <span class="p-column-title bold">{{ 'attribute.element'| transloco}}</span>
        {{state.id}}
      </td>
      <td *ngIf="!state.sensorIdentifier">
        <span class="p-column-title bold">{{ 'model.sensor'| transloco}}</span>
        <button
          [label]="'select.sensor' | transloco"
          (click)="stateBeingModified = state; measurementSensorOverlay.toggle($event);"
          pButton
          icon="pi pi-wifi"
        ></button>
      </td>
      <td
        *ngIf="state.sensorIdentifier"
        (click)="stateBeingModified = state; measurementSensorOverlay.toggle($event);"
      >
        <span class="p-column-title bold">{{ 'model.sensor'| transloco}}</span>
        <div class="flex justify-content-between align-items-center cursor-pointer">
          <p class="mb-0">
            {{uuidSensorMap.get(state.sensorIdentifier.entityUuid + '/' + (state.sensorIdentifier.sensorUuid ?? null))}}
          </p>
          <button
            pButton
            icon="pi pi-arrow-right-arrow-left"
            class="ml-2 p-button-icon-only p-button-text"
          ></button>
        </div>
      </td>
      <td>
        <span class="p-column-title bold">{{ 'attribute.state'| transloco}}</span>
        <p-dropdown
          [(ngModel)]="state.modifier.type"
          [options]="modifierOptions | translateLabels | async"
          [placeholder]="'misc.synopticModifierTypes.empty' | transloco"
          (ngModelChange)="state.modifier.args = generateDefaultArgsForModifier($event); onStatesChange();"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
        ></p-dropdown>
      </td>
      <td>
        <span class="p-column-title bold">{{ 'common.actions'| transloco}}</span>
        <div class="flex justify-content-end">
          <button
            [disabled]="!state.modifier.type"
            (click)="startEditingModifier(state)"
            pButton
            icon="pi pi-cog"
            class="ml-2 p-button-icon-only p-button-text py-1"
          ></button>
          <button
            (click)="duplicateState(state)"
            pButton
            icon="pi pi-clone"
            class="p-button-icon-only p-button-text py-1"
          ></button>
          <button
            (click)="removeState(state)"
            pButton
            class="p-button-icon-only p-button-text py-1"
            icon="pi pi-trash"
          ></button>
        </div>
      </td>
    </tr>
  </ng-template>

</p-table>

<p-overlayPanel #measurementSensorOverlay [showCloseIcon]="true" [style]="{width: '450px'}">
  <ng-template pTemplate>
    <app-synoptics-form-measurement-selector
      [deviceMeasurements]="deviceMeasurements"
      [assetMeasurements]="assetMeasurements"
      [kpis]="kpis"
      (selectionChange)="applySensorIdentifierToState(stateBeingModified, $event); measurementSensorOverlay.hide();"
    ></app-synoptics-form-measurement-selector>
  </ng-template>
</p-overlayPanel>
